// extracted by mini-css-extract-plugin
module.exports = {"input":"InputNumber_input__37bh9"};